import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/blur-background.vue
var s = {
	name: "DtIconBlurBackground",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--blur-background"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Blur Background",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.94 1.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm2 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm5.002 0a.56.56 0 1 1 1.121 0 .56.56 0 0 1-1.12 0Zm1.998 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0ZM6 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3.5 3.5a2.5 2.5 0 1 1 4.961.441.56.56 0 1 1-.374.935A2.498 2.498 0 0 1 6 6a2.498 2.498 0 0 1-2.086-1.122.559.559 0 0 1-.974-.378.56.56 0 0 1 .599-.559 2.515 2.515 0 0 1-.039-.44ZM1.94 3a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0ZM9 3a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H9.5A.5.5 0 0 1 9 3ZM.94 4.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm9 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-8 1.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm7 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-.81 1.08a.56.56 0 0 1 .93.466A2.5 2.5 0 0 1 10 9.5v1a.5.5 0 1 1-1 0v-1A1.5 1.5 0 0 0 7.5 8h-3A1.5 1.5 0 0 0 3 9.5v1a.5.5 0 1 1-1 0v-1a2.5 2.5 0 0 1 .941-1.955.56.56 0 0 1 .93-.465 2.5 2.5 0 0 1 .63-.08h3c.214 0 .425.028.63.08Zm1.81.42a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-9 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=blur-background.js.map